// extracted by mini-css-extract-plugin
module.exports = {"price":"ticker_price__pzh7e","content":"ticker_content__FgN5A","contentUl":"ticker_contentUl__YQh_U","star":"ticker_star__AnIQT"};